var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shows ? _c('div', {
    staticClass: "body-tool"
  }, [_c('tool-prev', {
    model: {
      value: _vm.items[_vm.index - 1],
      callback: function ($$v) {
        _vm.$set(_vm.items, _vm.index - 1, $$v);
      },
      expression: "items[index - 1]"
    }
  }), _c('tool-this', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.items[_vm.index],
      callback: function ($$v) {
        _vm.$set(_vm.items, _vm.index, $$v);
      },
      expression: "items[index]"
    }
  }), _c('tool-next', {
    model: {
      value: _vm.items[_vm.index + 1],
      callback: function ($$v) {
        _vm.$set(_vm.items, _vm.index + 1, $$v);
      },
      expression: "items[index + 1]"
    }
  })], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }